import Grid from '@mui/material/Grid';

const ListingSectionItem = ({ children, params }) => {
  return (
    <Grid display="flex" size={{ lg: 8, xs: 12 }} {...params}>
      {children}
    </Grid>
  );
};

export default ListingSectionItem;
